import { api } from 'src/pages/APIs';
import AbstractApiService from '../abstractApiService';
import type { dynamicObj } from 'src/pages/assets';

export default class DocXsltApiService extends AbstractApiService {
  public constructor() {
    super({});
  }
  public async getByEDocType(params: any): Promise<any> {
    return super.post(api.get_extraction_attributes, params, {});
  }
  public async listVersion(params: any): Promise<any> {
    return super.post(api.get_extraction_attribute_value_versions, params, {});
  }
  public async createExtractionAttributeValuesDraft(params: any): Promise<any> {
    return super.post(api.create_extraction_attribute_value_draft, params, {});
  }
  public async activateExtractionAttributeValueDraft(
    params: any,
  ): Promise<any> {
    return super.post(
      api.activate_extraction_attribute_value_draft,
      params,
      {},
    );
  }
  public async updateExtractionAttributeValueDraft(params: any): Promise<any> {
    return super.put(api.update_extraction_attribute_value_draft, params, {});
  }
  public async deleteExtractionAttributeValueDraft(params: any): Promise<any> {
    params.append('org_id', this.getOrgId());
    return super.delete(
      api.delete_extraction_attribute_value_draft,
      params,
      {},
    );
  }
  public async createExtractionAttribute(params: any): Promise<any> {
    return super.post(api.create_extraction_attribute, params, {});
  }
  public async deleleExtractionAttribute(params: any): Promise<any> {
    params.append('org_id', this.getOrgId());
    return super.delete(api.delete_extraction_attribute, params, {});
  }
  public async createExtractionAttributeValuesDraftFrom(
    params: any,
  ): Promise<any> {
    return super.post(
      api.create_extraction_attribute_value_draft_from,
      params,
      {},
    );
  }
  public async getPreviewOutput(params: any, headers: any): Promise<any> {
    return super.post(api.get_preview_output, params, headers);
  }
}
